import { storage } from '../compat/storage';

export type UpdateLastWatchedArgs = {
  referenceId: string;
  channelId: number;
  subLinearExternalId?: string;
  subProgramExternalId?: string;
};

export async function updateLastWatched({
  referenceId,
  channelId,
  subLinearExternalId,
  subProgramExternalId,
}: UpdateLastWatchedArgs) {
  const lastWatchedStats = await storage.getLastWatched();

  lastWatchedStats[referenceId] = { linearId: channelId, subLinearExternalId, subProgramExternalId };

  await storage.setLastWatched(lastWatchedStats);

  return lastWatchedStats;
}
